import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  clearScrollPosition,
  getScrollPosition,
} from "../Utils/scrollPositionManager";

export default function useScrollRestoration() {
  const location = useLocation();

  useEffect(() => {
    const y = getScrollPosition(location.pathname);
    if (y) {
      setTimeout(() => {
        window.scrollTo(0, y);
        clearScrollPosition(location.pathname); // optional if you want one-time restore
      }, 10);
    }
  }, [location.pathname]);
}
